import { LineChart } from '@mui/x-charts';
import { Card, CardBody, CardFooter, CardHeader, Row } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { Data } from '../../Pages/Dashboard';
import { useAppSelector } from '../../hooks';
import Loading from '../Loading';

type Props = {
    data: (number | null)[];
    data2: (number | null)[];
    labels: String[];
};

const SalesGraphQuarter = ({ data, data2, labels }: Props) => {
    const loading = useAppSelector((state) => state.sales.loading);

    return (
        <Card>
            <CardHeader className='bg-white'>
                <span style={{
                    textAlign: 'center',
                    marginBottom: 10,
                    fontSize: 16,
                    fontWeight: 'bold'
                }}>Sales (Quarterly)</span>
            </CardHeader>
            <CardBody style={{ overflow: 'hidden' }}>
                {loading 
                    ? (<Loading />)
                    : (
                        <LineChart
                            margin={{ left: 0, right: 10}}
                            xAxis={[
                                {
                                    scaleType: 'point',
                                    data: labels,
                                },
                            ]}
                            yAxis={[
                                {
                                    width: 55,
                                }
                            ]}
                            series={[
                                {
                                    data,
                                    label: 'Current Year',
                                    color: '#f1b434'
                                },
                                {
                                    data: data2,
                                    label: 'Last Year',
                                    color: 'lightgray'
                                },
                            ]}
                            height={300}                                
                        />
                    )
                }
            </CardBody>
            <CardFooter className='bg-white'>
                <Row>
                    <span style={{ textAlign: 'center' }}>Sales in thousands $</span>
                </Row>
            </CardFooter>
        </Card>
    )
};

export default SalesGraphQuarter;
